import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import './typography.css'

const ViewHeader = ({ children, className }) => <h5 className={cn('ViewHeader', className)}>{children}</h5>

ViewHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default ViewHeader
